<template>
  <div class="d-flex flex-column align-content-center profile-setup-games">
    <div class="profile-setup-width">
      <div class="input-icon-container">
        <InputSearch
          id="game-search"
          v-model="gameSearchModel"
          class="newInputGameSearch"
          :placeholder="$t('_web_game-find_placeholder', 'Find your game')"
        />
        <i
          ><img
            src="@/assets/images/auth/searchIcon.svg"
            alt="Search Icon"
            class="searchIcon"
          />
        </i>
      </div>
    </div>
    <div class="d-inline-flex flex-column align-self-center my-5">
      <ListPreloader
        :is-loading="gamesIsLoading"
        :is-empty-list="!filteredGames.length"
        :empty-list-label="
          $$t('We can\'t find game with this name', 'list-is-empty')
        "
      >
        <ImageCheckboxGroup
          v-show="filteredGames.length"
          slot="list"
          v-model="selectedGames"
          mode="card"
          class="checkbox-game secondary-font"
          :variants="filteredGames"
          :name="`games_${_uid}`"
          :img-size="211"
          without-check-all
        />
      </ListPreloader>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { translate } from '@/mixins/translate';
import { loader } from '@/mixins/isLoadingAlt';
import ListPreloader from '@/components/common/HeraListPreloader';
import ImageCheckboxGroup from '@/components/common/ImageCheckboxGroup';
import InputSearch from '@/components/atoms/form/HeraFormTextInput';

export default {
  name: 'ProfileSetupGames',
  components: {
    ListPreloader,
    ImageCheckboxGroup,
    InputSearch,
  },
  mixins: [loader('gamesIsLoading'), translate('_web_profile-setup_games')],
  data() {
    return {
      genreModel: null,
      gameSearchModel: '',
    };
  },
  computed: {
    ...mapGetters(['accountEditData', 'games']),
    filteredGames() {
      // use pagination (feature)
      let [...gamesList] = this.games || [];
      const gamesFilter = this.gameSearchModel.trim().toLowerCase();

      if (gamesFilter) {
        gamesList = gamesList.filter(({ nameLowerCase }) =>
          nameLowerCase.includes(gamesFilter)
        );
      }

      if (this.genreModel) {
        gamesList = gamesList.filter(
          game => game.genres && game.genres.includes(this.genreModel.id)
        );
      }

      return gamesList.map(({ logo, id, name }) => ({
        value: id,
        img: logo,
        title: name,
      }));
    },
    selectedGames: {
      get() {
        return this.accountEditData.games || [];
      },
      set(games) {
        var initialHeight = document.documentElement.scrollTop;
        this.updateEditData({ games });
        this.$nextTick(() => {
          document.documentElement.scrollTop = initialHeight;
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateEditData']),
  },
};
</script>

<style lang="scss">
.profile-setup-games {
  .checkbox-group_items-wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-gap: 12px 40px;
  }

  .input-icon-container {
    @include auto-rtl(display, flex);
    width: 58rem;
    border: 1px solid $new-border-neutral;
    background-color: $new-bg-base !important;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 5px;
    margin-bottom: 2rem;
  }

  .profile-setup-width {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .newInputGameSearch {
    width: 100%;
    background-color: $new-bg-base !important;
    border-radius: 5px;
  }

  .newInputGameSearch ::placeholder {
    color: $new-fg-neutral-faded !important;
  }

  .upper-main-container {
    padding-bottom: 1rem;
  }

  #InputField_game-search {
    color: $new-fg-neutral-faded !important;
    width: 100%;
    border: none;
    background-color: $new-bg-base !important;
    border-radius: 5px;
  }

  .searchIcon {
    margin-right: 5px;
  }

  .form-wrapper-second {
    width: 100% !important;
  }

  &_filter {
    flex-grow: 1;
    margin: 0 -1rem;
  }

  .checkbox-game {
    width: 58rem !important;
    padding-bottom: 5rem;
    .checkbox-group_card {
      .checkbox-group_item {
        text-align: center;
        .checkbox-group_border {
          width: 213px;
        }
        img {
          margin-bottom: 1rem;
          width: 3rem;
          height: 3rem;
          border-radius: 5px;
          justify-content: center;
          margin-top: 1rem;
          align-items: center;
        }
      }
    }

    .star-icon-fill {
      display: none;
    }

    .checkbox-group_input + span + img,
    .checkbox-group_input + span + img + span {
      opacity: 0.5;
    }

    .checkbox-group_input:checked + span + img,
    .checkbox-group_input:checked + span + img + span {
      opacity: 1;
    }

    .checkbox-group_input:checked + span + img + span + img {
      display: none;
    }

    .checkbox-group_input:checked + span + img + span + img + img {
      display: block;
    }

    .checkbox-group_input:checked + .checkbox-group_border {
      opacity: 0;
    }
  }
}
</style>
